import gql from 'graphql-tag'

export default gql`
    mutation SendSecondFactor($type: String!, $destination: String!, $factor: String!, $B2B: Boolean!) {
        sendSecondFactor(type: $type, destination: $destination, factor: $factor, B2B: $B2B) {
            status
        }
    }
`
